import React, { useState, useEffect, useContext } from "react";
import {useNavigate } from "react-router-dom";
import PaymentFun from "Components/Profile/Payment/PaymentFun";
import './ImageSilder.css';

import AppContext from "Contexts/AppContext";
import BuyCardData from "./BuyCardData";
const BornToWinCard: React.FC = () => {
  const {buyProduct} = useContext(AppContext);
  const [quantity, setQuantity] = useState(1);  
  const [totalPrice, setTotalPrice] = useState(buyProduct?.priceUsd);  



const navigate = useNavigate();
  
useEffect(() => {
  if(Object.keys(buyProduct).length === 0)navigate("/buyget")     
    setTotalPrice(quantity * buyProduct?.priceUsd)
 }, [buyProduct?.priceUsd,quantity]);  
  return (
   <> 
    <div className="container">
      <BuyCardData
      setQuantityValue={setQuantity}       
      />
    </div>
    {buyProduct?.remaining > 0 ? (
      <PaymentFun
        totalPrice={totalPrice}
        quantity={quantity}
      />
    ) : (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        marginTop: '20px',
        padding: '20px'
      }}>
        <button 
          style={{
            backgroundColor: 'af56fe',
            color: 'black',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'not-allowed',
            opacity: 0.7
          }}
          disabled
        >
          out of stock
        </button>
      </div>
    )}
   </>
  );
};

export default BornToWinCard;
